var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealEstateBroker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 173",
    enableBackground: "new 0 0 256 173",
    xmlSpace: "preserve",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M128.253,56.864c15.186,0,27.432-12.247,27.432-27.432S143.536,2,128.253,2 c-15.186,0-27.432,12.247-27.432,27.432C100.918,44.716,113.165,56.864,128.253,56.864z M64.571,136.32h-49.28 c-15.969,0-16.851-24.395,0.294-24.395H58.3l24.493-36.054c7.25-9.895,15.48-14.598,27.138-14.598h36.544 c11.659,0,19.888,4.311,27.138,14.598l24.591,36.054h43.01c17.243,0,16.165,24.395,0.588,24.395h-49.28 c-3.919,0-8.622-1.372-11.365-5.584l-18.811-26.844l-0.098,67.209H94.844l-0.098-67.209l-18.811,26.844 C73.192,134.85,68.49,136.32,64.571,136.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,100h-21.913V85.625h-9.35V100h-21.913V31.339h13.148v-4.967h26.88v4.967H254V100z M218.355,66.341h-8.765v8.765h8.765 V66.341z M218.355,53.252h-8.765v8.765h8.765V53.252z M218.355,40.104h-8.765v8.765h8.765V40.104z M232.087,66.341h-9.35v8.765h9.35 V66.341z M232.028,62.017v-8.765h-4.616h-0.058h-4.616v8.765h9.35H232.028z M232.087,40.104h-4.616h-0.058h-4.616v8.765h4.616h0.058 h4.616V40.104z M245.235,66.341h-8.765v8.765h8.765V66.341z M245.235,53.252h-8.765v8.765h0.76h8.006V53.252z M245.235,40.104 h-8.765v8.765h8.765V40.104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.924,68.48c0,1.924-1.56,3.537-3.537,3.537c-1.04,0-2.029-0.468-2.653-1.196l-4.161-3.849V100H40.683V76.721h-12.82V100 H12.767V66.711l-4.785,4.317c-0.624,0.624-1.508,0.988-2.445,0.988C3.612,72.017,2,70.456,2,68.48c0-1.092,0.52-2.133,1.3-2.757 L34.3,38l9.31,8.478V39.3h7.958v14.46L65.04,66.087C65.612,66.711,65.924,67.544,65.924,68.48z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shopping_cart"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cross"
  }), /*#__PURE__*/React.createElement("g", {
    id: "leaf"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstateBroker);
export default __webpack_public_path__ + "static/media/realEstateBroker.e5eb9288832da702acde38f407e167bd.svg";
export { ForwardRef as ReactComponent };